import React, { useState } from 'react';

export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: 'How are the 75 recipients selected?',
      a: 'Every application is reviewed personally by the author. The criteria: you lead or co-lead HR at a 1,000+ employee organisation in India, and you are navigating AI in your function. No algorithm. Just judgment.'
    },
    {
      q: 'Is there any obligation?',
      a: 'None whatsoever. No review. No social post. No follow-up pitch. The book is sent because the frameworks were designed for people in your position.'
    },
    {
      q: 'What if all 75 copies are claimed?',
      a: 'You stay on the waitlist for priority launch notification and early platform access. The waitlist has value even after the 75 copies are gone.'
    },
    {
      q: 'When can I purchase the book?',
      a: 'The book is in print. Public availability will be announced to the waitlist before any other channel.'
    },
    {
      q: 'What is AIFirstCHRO.com?',
      a: 'The companion platform. Interactive assessments, diagnostic tools, team variance analysis, downloadable resources — all grounded in the book\'s six frameworks. First 75 readers receive priority beta access.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="section-wrap">
      <div className="faq-inner">
        <div className="section-label">Questions</div>
        <div className="section-title">Before you apply</div>
        
        {faqs.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? 'open' : ''}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-q">
              {item.q}
              <span>+</span>
            </div>
            <div className="faq-a">{item.a}</div>
          </div>
        ))}
      </div>
    </section>
  );
};
